// import siteInfo from "@/constants/siteInfo";
import Head from "next/head";

const ProfilePageSchema = ({
  title = "",
  canonical_url = "",
  publishedAt = "",
  modifiedAt = "",
  authorName = "",
  authorCanonicalUrl = "",
}) => {
  return (
    <Head>

      <script
        id="ProfilePageSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfilePage",
            mainEntity: {
              "@type": "Person",
              "@id": authorCanonicalUrl?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${authorCanonicalUrl}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
              name: authorName,
            },
            hasPart: {
                "@type": "Article",
                headline: title,
                url: canonical_url?.includes(
                    process.env.NEXT_PUBLIC_WEBSITE_URL
                  )
                    ? `${canonical_url}`
                    : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
                datePublished: publishedAt,
                author: {
                    "@type": "Person",
                    "@id":  authorCanonicalUrl?.includes(
                        process.env.NEXT_PUBLIC_WEBSITE_URL
                      )
                        ? `${authorCanonicalUrl}`
                        : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
                    name: authorName,
                }
            }
          }),
        }}
      />
    </Head>
  );
};

export default ProfilePageSchema;
